import { render, staticRenderFns } from "./BAteTreeListCount.vue?vue&type=template&id=0b59946d&"
import script from "./BAteTreeListCount.vue?vue&type=script&lang=js&"
export * from "./BAteTreeListCount.vue?vue&type=script&lang=js&"
import style0 from "./BAteTreeListCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VSkeletonLoader})
